import { KettleAlertIcon } from './KettleAlertIcon';

/**
 * author: Michael Irigoyen
 * id 123DA4E5-7243-4495-8CE4-2CDA32A65C01
 * name kettle-alert
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/kettle-alert.svg
 * tags
 * - Home Automation 
 * - Alert / Error 
 * - Food / Drink 
 */
export const TeaKettleFullAlertIcon = KettleAlertIcon;
export default TeaKettleFullAlertIcon